import React, { Component } from 'react';
import './App.css';
import {
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom'
// import Login from './login'
import { FirestoreProvider } from 'react-firestore';
import Home from './home'
import VerfidNavbar from './components/navbar'
import BusinessRegistration from './components/businessAccountRegistration'
import gift from './components/gift'
import Logo from './logoText.png'
import PawStrip from './Paw Strip Registered.png'
import Profile from './Profile'
import { StripeProvider } from 'react-stripe-elements';
import { firebase } from './utils/firebase';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import appReducer from './redux/reducers';
import AnimalRegistration from './components/animalAccountRegistration';
import payment from './components/payment';
import forgotPassword from './components/forgotPassword';
import date from './components/date';


const Contact = () => (
  <div>
    <h4>Send us an email:</h4>
    <h4>support@verfidservices.com</h4>
    <br></br>
    <h4>Visit us on social media:</h4>
    {/*<a href="https://www.facebook.com/verfidservices/"> <img src= {facebook} className= "footerImages" alt="Facebook"/></a>
    <a href="https://www.twitter.com/verfid_services/"> <img src= {twitter} className= "footerImages" alt="Twitter"/></a>
    <a href="https://www.instagram.com/verfid_services/"> <img src= {instagram} className= "footerImages" alt="Instagram"/> </a>
    */}<br></br>
    <br></br>
  </div>
)



const HomePage = () => (
  <div>
    <h1>The VERFID site has moved...</h1>
    <h3>If you are trying to create or edit your account, please use the links below</h3>
    <br></br>
    <a href='/companysignup'>Create a Business Account</a>
    <br></br>
    <br/>
    <a href='/signup'>Create an Animal Account</a>
    <br></br>
    <br/>
    <a href='/login'>Login to Edit Your Account</a>
    <br></br>
    <br/>
    <h3>Use the link below to go to our main website</h3>
    <a href='https://verfidpet.com'>Main Website</a>
  </div>
)

const PrivateRoute = ({component: Component, authenticated, ...rest}) => {
  return (
    <Route
      {...rest}
      render={(props) => props.user !== null
        ? <Component {...props} />
        : <Redirect to={{pathname: '/home', state: {from: props.location}}} />}
    />
  )
};

const store = createStore(appReducer);

class App extends Component {
  constructor() {
    super() 

    this.state = {
      authUser: '',
    }
  }
  render() {
    return (
    <Provider store={store}>
    <FirestoreProvider firebase={firebase}>
    <StripeProvider apiKey="pk_live_UwIs0hdEkub5YFmKJt8cVgyh">
    <div>
    <hr style={{height: 20, backgroundColor:'#251F5F', marginTop:'0', marginBottom:'0'}}/> 
      <div className="App" >
      <img src={Logo} id="topLogo" />
      <div className="nav">
      <VerfidNavbar /> 
      </div>
      <div className="sectionBlock">
        <Switch>
          <Route exact path="/" component={AnimalRegistration} store={store}/>
          <Route path="/login" component={Home} login={this.login}/>
          <Route path="/signup" component={AnimalRegistration} store={store}/>
          <Route path="/companySignUp" component={BusinessRegistration} />
          <Route path="/gift" component={gift} />
          <Route path="/payment" component={payment} />
          <Route path="/passwordReset" component={forgotPassword} />
          <Route path="/date" component={date} />
          <PrivateRoute path="/profile" component={Profile} store={store}/>
        </Switch>
      </div>
      </div>
        <div>
          <br/> <br/> <br/> 
          <h5 id="bottomLogo2">VERFID LLC © 2020 - All Rights Reserved</h5>
          <a href={'https://verfidpet.com/privacy-policy-1'} id="bottomLogo2">Privacy Policy &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Terms</a>
          <img src={PawStrip}  id="bottomLogo"/>
        </div>
      </div>
       </StripeProvider>    
    </FirestoreProvider>
    </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js